import { call, put, takeEvery } from "redux-saga/effects"

import {
    CREATE_USER_TERMS_OF_SERVICE,
    GET_LATEST_TERMS_OF_SERVICE,
    GET_TERMS_OF_SERVICE,
    GET_USER_TERMS_OF_SERVICE,
    POST_TERMS_OF_SERVICE,
} from "./actionTypes"

import {
    getTermsOfServiceSuccess,
    getTermsOfServiceError,
    postTermsOfServiceSuccess,
    postTermsOfServiceError,
    getLatestTermsOfServiceSuccess,
    getLatestTermsOfServiceError,
    getUserTermsOfServiceSuccess,
    getUserTermsOfServiceError,
    createUserTermsOfServiceSuccess,
    createUserTermsOfServiceError,
} from "./actions"

import {
    genericGetRequest, genericPostRequest, postWithFileUploader
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails, bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetTermsOfService(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_terms_of_services`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getTermsOfServiceSuccess(response))
    } catch (error) {
        yield put(getTermsOfServiceError(error))
    }
}

function* onPostTermsOfService(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_terms_of_services`;
        const payload = {
            body: {
                ...action.payload,
            },
            headers: {
                Authorization: user.token,
            }
        }
        const response = yield call(postWithFileUploader, URL, payload)
        yield put(postTermsOfServiceSuccess(response))
    } catch (error) {
        yield put(postTermsOfServiceError(error))
    }
}

function* onGetLatestTermsOfService() {
    try {
        let user = bsh_getClientUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/latest_terms_of_service`;
        const response = yield call(
            genericGetRequest,
            URL,
            {},
            {
                'Authorization': user.token,
                'Content-Type': 'application/json'
            }
        )
        yield put(getLatestTermsOfServiceSuccess(response))
    } catch (error) {
        yield put(getLatestTermsOfServiceError(error))
    }
}

function* onGetUserTermsOfService(action) {
    try {
        let admin_user = bsh_getAdminUserDetails();
        let user = JSON.parse(localStorage.getItem("authUser")).user
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/user_terms_of_services`,
            action.payload?.queryParams,
            {
                Authorization: admin_user.token,
                'account-id': user.account_id
            }
        )
        yield put(getUserTermsOfServiceSuccess(response))
    } catch (error) {
        yield put(getUserTermsOfServiceError(error))
    }
}

function* onCreateUserTermsOfService(action) {
    try {
      let user = JSON.parse(localStorage.getItem("authUser")).user
      const response = yield call(
        genericPostRequest,
        `${AppConfiguration.BACKEND_URL}/api/v1/user_terms_of_services`,
        {
          body: JSON.stringify({
            ...action.payload
          }),
          headers: {
            Authorization: user.token,
            'account-id': user.account_id,
            'Content-Type': 'application/json',
          },
        }
      )
      yield put(createUserTermsOfServiceSuccess(response))
    } catch (error) {
      yield put(createUserTermsOfServiceError(error))
    }
}

function* TermsOfServicesSaga() {
    yield takeEvery(GET_TERMS_OF_SERVICE, onGetTermsOfService)
    yield takeEvery(POST_TERMS_OF_SERVICE, onPostTermsOfService)
    yield takeEvery(GET_LATEST_TERMS_OF_SERVICE, onGetLatestTermsOfService)
    yield takeEvery(GET_USER_TERMS_OF_SERVICE, onGetUserTermsOfService)
    yield takeEvery(CREATE_USER_TERMS_OF_SERVICE, onCreateUserTermsOfService)
}

export default TermsOfServicesSaga

